"use client";

import React, { ReactNode, useContext, useMemo } from "react";



// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { ProductTileBrandInfoClickContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/__internal__/ProductTileBrandInfoClickContext";



import { MarketplaceProductBrandLink } from "../../MarketplaceProductBrandLink";


interface ISearchMarketplaceProductBrandLinkProps {
  brandToken: string | undefined;
  children: ReactNode;
}

export const SearchMarketplaceProductBrandLink: React.FC<
  ISearchMarketplaceProductBrandLinkProps
> = ({ brandToken, children }) => {
  const {
    onBrandClick,
    onBrandLinkFocus,
    onBrandLinkBlur,
    generateBrandUrl,
  } = useContext(ProductTileBrandInfoClickContext);
  const brandUrl = useMemo(
    () => generateBrandUrl?.(brandToken ?? ""),
    [brandToken, generateBrandUrl]
  );

  return (
    <MarketplaceProductBrandLink
      token={brandToken}
      onClick={(ev) => {
        onBrandClick?.(ev);
      }}
      onMouseEnter={() => {
        onBrandLinkFocus?.();
      }}
      onMouseLeave={() => {
        onBrandLinkBlur?.();
      }}
      onFocus={() => {
        onBrandLinkFocus?.();
      }}
      onBlur={() => {
        onBrandLinkBlur?.();
      }}
      onTouchStart={() => {
        onBrandLinkFocus?.();
      }}
      data-test-id="marketplace-product-brand-link"
      to={brandUrl}
    >
      {children}
    </MarketplaceProductBrandLink>
  );
};
